/**
 * DevExtreme (esm/__internal/ui/text_box/texteditor_button_collection/m_custom.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../../core/renderer";
import {
    extend
} from "../../../../core/utils/extend";
import {
    name as clickEventName
} from "../../../../events/click";
import eventsEngine from "../../../../events/core/events_engine";
import {
    end,
    start
} from "../../../../events/hover";
import Button from "../../../../ui/button";
import TextEditorButton from "./m_button";
var CUSTOM_BUTTON_HOVERED_CLASS = "dx-custom-button-hovered";
export default class CustomButton extends TextEditorButton {
    _attachEvents(instance, $element) {
        var {
            editor: editor
        } = this;
        eventsEngine.on($element, start, () => {
            editor.$element().addClass(CUSTOM_BUTTON_HOVERED_CLASS)
        });
        eventsEngine.on($element, end, () => {
            editor.$element().removeClass(CUSTOM_BUTTON_HOVERED_CLASS)
        });
        eventsEngine.on($element, clickEventName, e => {
            e.stopPropagation()
        })
    }
    _create() {
        var {
            editor: editor
        } = this;
        var $element = $("<div>");
        this._addToContainer($element);
        var instance = editor._createComponent($element, Button, extend({}, this.options, {
            ignoreParentReadOnly: true,
            disabled: this._isDisabled(),
            integrationOptions: this._prepareIntegrationOptions(editor)
        }));
        return {
            $element: $element,
            instance: instance
        }
    }
    _prepareIntegrationOptions(editor) {
        return extend({}, editor.option("integrationOptions"), {
            skipTemplates: ["content"]
        })
    }
    update() {
        var isUpdated = super.update();
        if (this.instance) {
            this.instance.option("disabled", this._isDisabled())
        }
        return isUpdated
    }
    _isVisible() {
        var {
            editor: editor
        } = this;
        return editor.option("visible")
    }
    _isDisabled() {
        var isDefinedByUser = void 0 !== this.options.disabled;
        if (isDefinedByUser) {
            return this.instance ? this.instance.option("disabled") : this.options.disabled
        }
        return this.editor.option("readOnly")
    }
}
